<template>
  <div class="layout-product-available">
    <template
        v-if="offers.length"
        v-for="(offer, index) in offers"
    >
      <div class="s-14 w-600" v-if="offer.PROPERTIES.GABARITY && offer.PROPERTIES.GABARITY.VALUE">
        {{ offer.PROPERTIES.GABARITY.VALUE }} см
      </div>
      <div class="s-14 w-600" v-else-if="offer.PROPERTIES.RAZMER && offer.PROPERTIES.RAZMER.VALUE">
        {{ offer.PROPERTIES.RAZMER.VALUE }}
      </div>

      <div>
        <ui-label v-if="offer.STORE || offer.STORE_UD_SKLAD || Number(offer.CATALOG_QUANTITY) > 0">в наличии</ui-label>
      </div>
      <div class="s-14 w-500" v-if="offer.STORE || offer.STORE_UD_SKLAD || Number(offer.CATALOG_QUANTITY) > 0">
         доставка возможна в течении 24 часов
      </div>
      <div class="s-14 w-500" v-else>
        {{ srok_dostavki }}
      </div>
      <div class="button" @click="addBasketProduct(offer)">
      <icon-bag></icon-bag>
      <span class="s-14 w-600" v-html="formatPrice( offer.MIN_PRICE.DISCOUNT_VALUE )"></span>
    </div>

    </template>
  </div>
</template>

<script>
export default {
  props:{
    id: "",
    srok_dostavki: ""
  },
  data() {
    return {
      offers: [],
    }
  },
  methods:{
    formatPrice(price) {
      return Math.ceil(Number(price)).toLocaleString() + " <span class='ruble'>"+ this.$store.state.langs.CURRENCY_SING+"</span>"
    },
    addBasketProduct(offer){
      let id = offer.ID;
      let name = offer.NAME;
      let price = offer.MIN_PRICE.DISCOUNT_VALUE;

      this.$axios({
        url: '/ajax/?id='+id+'&add_basket=Y&CATALOG_ID='+this.$store.state.langs.CATALOG_ID+'&GROUP_USER_ID='+this.$store.state.langs.GROUP_USER_ID+'&SITE_ID='+this.$store.state.siteid, method: 'post'
      }).then(response => {
        if (response.status == 200) {
          var count = Number(response.data.productCount);
          this.$bus.$emit("smallbasket", count);
          let productBascet = {name:name,price:price,image:this.image}
          this.$bus.$emit('in-cart', productBascet);
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            "ecommerce": {
              "currencyCode": "RUB",
              "add": {
                "products": [
                  {
                    "id": id,
                    "name" : name,
                    "price": price,
                    "brand": offer.brand,
                    "category":  offer.iblockInfo.NAME + "/" + offer.brand + "/" + name,
                    "variant" : this.size,
                    "quantity": 1
                  }
                ]
              }
            }
          });
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'add2cart');
          }
        }
      }).catch(e => {
        console.log('Error: ' + e)
      });
    },
    async findContetn(){
      const  offers  = (
          await this.$axios({
            url: '/ajax/offers-product.php?id='+this.id,
            method: 'post',
            params: {}
          })
      )
      if (offers) {
        this.offers = offers.data;
      } else {
        console.log('error offers')
      }
    },
  },
  mounted() {
    if (typeof (ym) === "function") {
      let yaCounterId = this.$store.state.langs.YACOUNTER;
      ym(yaCounterId, 'reachGoal', 'availability_block_open');
    }
    if(!this.offers.length && this.id!="") {
      this.findContetn();
    }
  },

}
</script>

<style lang="scss" scoped>
.layout-product-available {
  display: grid;
  grid-template-columns: auto auto 1fr max-content;
  align-items: center;
  line-height: 16px;
  gap: 20px;
  .button {
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color);
    color: #fff;
    cursor: pointer;
    gap: 6px;
    border-radius: 100px;
    height: 35px;
    padding: 0 10px;
    transition: 0.3s;
    cursor: pointer;
    svg {
      height: 16px;
    }
    &:hover {
      transform: scale(1.05);
    }
  }
}
@media screen and (max-width: 767px) {
  .layout-product-available {
    gap: 8px;
    .ui-label {
      font-size: 12px;
    }
  }
}
</style>
